<fieldset>
  <legend>
    ChampLibreGroup
  </legend>
  <button (click)="addchampsLibre()" class="btn btn-outline-primary">Ajouter un champsLibre</button>
  <div *ngFor="let obj of champLibreGroup.champsLibre; let i = index">
    <fieldset>
      <legend>
        champsLibre {{ i + 1}}
      </legend>
      <button (click)="removechampsLibre(i)" class="btn btn-outline-primary">Supprimer un champsLibre</button>
      <app-form-input  [label]="'champsLibre'"
                      [name]="getUid()+'_index_'+(i+1)+'_SepAtt_champsLibre'"
                      [parentForm]="parentForm" [rule]="''" [type]="'text'"
                      [value]="obj">
      </app-form-input>
    </fieldset>
  </div>
</fieldset>
